import { notification } from 'antd';
import type React from 'react';

type NotificationType = 'success' | 'info' | 'warning' | 'error';
type NotificationPlacement =
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight';

interface NotificationParams {
    type: NotificationType;
    title: string;
    description?: string;
    icon?: React.ReactNode;
    duration?: number;
    placement?: NotificationPlacement;
}

// Standalone notification function
const notify = ({
    type,
    title,
    description,
    icon,
    duration = 1.5, // Default duration
    placement = 'bottomRight', // Default position
}: NotificationParams) => {
    notification[type]({
        message: title,
        description,
        icon,
        duration,
        placement,
    });
};

export default notify;
